import { action, observable, makeObservable } from 'mobx';

class CachedImagesStore {
  @observable cachedImages = observable.map<string, boolean>({}, { deep: false });

  constructor() {
    makeObservable(this);
  }

  @action
  addCachedImage(url: string, state: boolean): void {
    this.cachedImages.set(url, state);
  }

  isCachedImage(url: string): boolean {
    return this.cachedImages.get(url) || false;
  }
}

export const CachedImages = new CachedImagesStore();
